// extracted by css-extract-rspack-plugin
export default {"bottom-sheet-wrapper":"AdditionalActions-module__bottom-sheet-wrapper--iMAem","bottomSheetWrapper":"AdditionalActions-module__bottom-sheet-wrapper--iMAem"};